module.exports = __webpack_public_path__ + "static/img/7.d803bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/7.png
// module id = F+1u
// module chunks = 4